import React, { useEffect } from 'react'
import LoanRatesContainer from '../containers/LoanRates'
import Nav from '../components/nav/Nav';

const LoanRates: React.FC= () => {

  useEffect(() => {
    document.title = 'Elite Community CU | Loan Rates';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "New Car Used Vehicles Shared Secured Personal Home Equity **LTV - Loan To Value NLMS#: 506334Note: New Loan Rates Effective 01/01/2018. Rates Subject To ...";
    document.head.appendChild(metaDescription);
  }, []);


  return (
    <div>
      <Nav />
      <LoanRatesContainer />
    </div>
  )
}

export default LoanRates